module.exports = __webpack_public_path__ + "static/media/fa-regular-400.a03df7ab.eot";